import moment from 'moment-timezone'

/**
 * Gets the nearest time value, by 30-min increments
 */
export const getClosestTime = (
  timeMoment?: moment.Moment,
  timezone: string = moment.tz.guess(),
  addHours: number = 0
): moment.Moment => {
  const now =
    timeMoment !== undefined && moment(timeMoment).isValid()
      ? moment(timeMoment).tz(timezone)
      : moment().tz(timezone)
  return now
    .startOf('minute')
    .add(now.minutes() > 30 ? addHours + 1 : addHours, 'h')
    .minutes(now.minutes() > 30 ? 0 : 30)
}
